import React, { useEffect, useState } from "react";
import "./EmissionsHome.scss";
import ScopeSelection from "./ScopeSelection/ScopeSelection";
import ActivityData from "./ActivityData/ActivityData";
import EmissionsSummary from "./EmissionsSummary/EmissionsSummary";
import { emissionScopeService } from "../../services/emissionService";
import { toastMessage } from "../../helper";
import FileUpload from "../FileUploadPage/FileUploadPage";
import { fetchBusinessUnit } from "../../services/orgService";
import EmissionDetailedView from "./EmissionDetailedView/EmissionDetailedView";
import { STEPS, UPLOAD_TYPE } from "../../constants/enums";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AssetActivityData from "./AssetActivityData/AssetActivityData";
const EmissionsHome = () => {
  const { t, i18n } = useTranslation();
  const [assetsList, setAssetsList] = useState([] as any[]);
  const [selectedAssetsData, setSelectedAssetsData] = useState({});
  const [step, setStep] = useState(STEPS.SELECT_SCOPE);
  const [categoryPreferences, setCategoryPreferences] = useState([]);
  const [businessUnitPreference, setBusinessUnitPreference] = useState<any>({});
  const [categoryPreference, setCategoryPreference] = useState(
    STEPS.SELECT_SCOPE
  );
  const [uploadType, setUploadType] = useState(UPLOAD_TYPE.MANUAL);
  const [isDirectEmissionApprovalEnable, setIsDirectEmissionApprovalEnable] =
    useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({} as any);
  const [emissionData, setEmissionData] = useState({});
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isBulkUpload, setIsBulkUpload] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [emissionDetail, setEmissionDetail] = useState("detail");
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  useEffect(() => {
    if (step === STEPS.EMISSION_SUMMARY) {
      setOpen(true);
      // setIsBulkUpload(true);
    }
  }, [step]);

  useEffect(() => {
    getScopeCategories();
  }, []);
  const getScopeCategories = async () => {
    let prefData = (
      await fetchBusinessUnit(
        JSON.parse(localStorage.getItem("currentBusinessUnit") || "").id
      )
    ).data;
    let categoryPreferences = prefData.categoryPreferences;
    setBusinessUnitPreference(prefData.businessUnitPreferences);
    setIsDirectEmissionApprovalEnable(
      prefData.businessUnitPreferences.directEmissionApproval
    );
    setCategoryPreferences(categoryPreferences);
    let key =
      localStorage.getItem("protocol") == "ghg" ? "ghgCategory" : "category";
    emissionScopeService({
      categories: categoryPreferences
        .sort((category1: any, category2: any) => {
          return category1.category - category2.category;
        })
        .map((eachPreference: any) => eachPreference[key])
        .toString(),
    })
      .then((res) => {
        setCategoryData(res.data);
      })
      .catch((err) => {
        setIsLoading(false);
        toastMessage(err?.response?.data?.message, "error");
      });
  };
  const { state } = useLocation();
  return (
    <div className="pw-emission-home w-full  flex flex-row grow">
      <div className="pw-creation-side-bar">
        <div
          className={`pw-usetiful-scope pw-org-side-elem ${
            step === STEPS.SELECT_SCOPE ? "pw-org-active" : "pw-org-inactive"
          }`}
          onClick={() => {
            setStep(STEPS.SELECT_SCOPE);
          }}
        >
          {state.step === STEPS.ASSETS ? t("Select Assets") : t("Select Scope")}
        </div>
        <div
          className={`pw-usetiful-activity pw-org-side-elem ${
            step === STEPS.ACTIVITY_DATA || step === STEPS.ASSETS
              ? "pw-org-active"
              : "pw-org-inactive"
          }`}
          onClick={() => {
            if (state.step === STEPS.CATEGORYWISE) {
              setStep(STEPS.ACTIVITY_DATA);
            }
          }}
        >
          {t("Activity Data")}
        </div>
      </div>
      <div className="overflow-y-auto pw-emission-home-main">
        {step === STEPS.SELECT_SCOPE && (
          <ScopeSelection
            assetsList={assetsList}
            setSelectedAssetsData={setSelectedAssetsData}
            setAssetsList={setAssetsList}
            setStep={setStep}
            setUploadType={setUploadType}
            categoryData={categoryData}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            categoryPreference={categoryPreference}
            categoryPreferences={categoryPreferences}
            setCategoryPreferences={setCategoryPreferences}
            isBulkUpload={isBulkUpload}
            setIsBulkUpload={setIsBulkUpload}
          />
        )}
        {step === STEPS.ACTIVITY_DATA && uploadType === UPLOAD_TYPE.MANUAL && (
          <ActivityData
            isDirectEmissionApprovalEnable={isDirectEmissionApprovalEnable}
            setStep={setStep}
            setEmissionData={setEmissionData}
            selectedCategory={selectedCategory}
            businessUnitPreference={businessUnitPreference}
            categoryPreferences={categoryPreferences}
          />
        )}
        {step === STEPS.ASSETS && uploadType === UPLOAD_TYPE.MANUAL && (
          <AssetActivityData
            setStep={setStep}
            isDirectEmissionApprovalEnable={isDirectEmissionApprovalEnable}
            emissionData={emissionData}
            setEmissionData={setEmissionData}
            selectedCategory={selectedCategory}
            selectedAssetsData={selectedAssetsData}
          />
        )}
        {step === STEPS.ACTIVITY_DATA &&
          uploadType === UPLOAD_TYPE.BULKUPLOAD && (
            <FileUpload
              setStep={setStep}
              setShowErrorDialog={setShowErrorDialog}
              selectedCategory={selectedCategory}
              setEmissionData={setEmissionData}
              uploadedFiles={uploadedFiles}
              setUploadedFiles={setUploadedFiles}
              categoryPreferences={categoryPreferences}
              isDirectEmissionApprovalEnable={isDirectEmissionApprovalEnable}
            />
          )}
      </div>
      {step === STEPS.EMISSION_SUMMARY && (
        <EmissionsSummary
          setStep={setStep}
          open={open}
          showErrorDialog={showErrorDialog}
          setShowErrorDialog={setShowErrorDialog}
          setOpen={setOpen}
          selectedCategory={selectedCategory}
          emissionData={emissionData}
          isBulkUpload={isBulkUpload}
          setIsBulkUpload={setIsBulkUpload}
          uploadedFiles={uploadedFiles}
        />
      )}
      {step === STEPS.EMISSION_DETAILED_VIEW && emissionDetail === "detail" && (
        <EmissionDetailedView
          setStep={setStep}
          open={open}
          setOpen={setOpen}
          emissionDetail={emissionDetail}
          setEmissionDetail={setEmissionDetail}
        />
      )}
    </div>
  );
};

export default EmissionsHome;
